import r from"./BetterOffer.js";import o from"./Carousel.js";import t from"./List.js";import i from"./QuickClick.js";import e from"./Trending.js";var f={betteroffer:r,carousel:o,list:t,quickclick:i,trending:e};export{f as default};
